<template>
  <div id="workLeave">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div ref="fresh" :style="{height:freshHeight +'px','overflow-y':'scroll','box-sizing': 'border-box','padding-bottom':'80px'}">
        <van-cell
          v-for="info in workLeaves"
          :key="info.leave_num"
          :title="worktimeChange(info)"
          :label="info.reason"
          @click="showCreate(info)"
        ><span>{{ leaveTypeChange(info) }}</span>
          <br>
          <span :style="{ color: leaveStatusSet(info.approval)}">{{ approvalStatusChange(info) }}</span>
        </van-cell>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import request from '@/utils/request'
const moment = require('moment')
const approvals = { '0': '未批准', '1': '已批准', '2': '已拒绝', '3': '批准中' }

export default {
  name: 'WorkLeave',
  components: { },
  data() {
    return {
      workLeaves: [],
      isLoading: false,
      freshHeight: '100%'
    }
  },
  created: function() {
    this.onRefresh()
  },
  mounted() {
    this.freshHeight = document.documentElement.clientHeight - this.$refs.fresh.getBoundingClientRect().top
  },
  methods: {
    worktimeChange(info) {
      if (info.leave_flg === '0') {
        return moment(info.leave_time_s).format('YYYY-MM-DD') + '~' + moment(info.leave_time_e).format('YYYY-MM-DD')
      } else {
        return moment(info.leave_time_s).format('YYYY-MM-DD') + ' ' + moment(info.leave_time_s).format('HH:mm') + '-' + moment(info.leave_time_e).format('HH:mm')
      }
    },
    leaveTypeChange(info) {
      const status = this.GLOBAL.BASE_LEAVE_STATUS
      return status[info.leave_type]
    },
    approvalStatusChange(info) {
      return approvals[info.approval]
    },
    showCreate(info) {
      this.$parent.leavePage.mode = false
      this.$parent.leavePage.info = info
      this.$parent.popupleaveCreate = true
      this.$parent.existModel = false
      this.$nextTick(() => { this.$parent.existModel = true })
    },
    leaveStatusSet(approval) {
      switch (approval) {
        case '1': return 'green'
        case '2': return 'red'
        case '3': return 'blue'
        default: return 'orange'
      }
    },
    onRefresh() {
      const self = this
      const params = this.$parent.params
      // 加入部门code
      params.department = this.$store.getters.department.split(',')[0]
      self.workLeaves = []
      request({ url: '/O00/WorkLeaves', params: params })
        .then(function(response) {
          if (response.code === 0) {
            self.workLeaves = response.data
          }
          self.isLoading = false
        })
        .catch(function(error) {
          self.isLoading = false
          self.$toast.fail(error)
        })
    }
  }
}
</script>

<style scoped>
.van-cell__value{
  max-width: 30%
}
</style>
